import { IntegrationCredentialStatus } from './IntegrationCredentialStatus'
import { InverterManufacturer } from './InverterManufacturer'
import { Model } from './Model'
import { IntegrationCredentialStatusEnum } from '@/enums'
import { api, feature, Options, Params, Payload } from '@/services'
import { IdType, IntegrationDataType } from '@/types'

export class Integration extends Model {
    static endpoint = 'api/v1/company/integrations'

    raw: IntegrationDataType

    status: IntegrationCredentialStatus

    manufacturer: InverterManufacturer

    matched_systems_count: number

    warranties_count: number

    company_id: IdType

    user?: string

    secret?: string

    contact_name?: string

    account_id?: string

    contact_email?: string

    api_key?: string

    status_change_detected_at?: Date


    constructor(data: IntegrationDataType) {
        super(data)
        this.raw = data
        this.manufacturer = InverterManufacturer.find(data.provider)
        this.status = IntegrationCredentialStatus.find(this.manufacturer.isOther ||
            (this.manufacturer.isTesla && !feature('tesla-integration'))
            ? IntegrationCredentialStatusEnum.UNSUPPORTED : data.status)

        this.matched_systems_count = Model.toNumber(data.matched_systems_count, 0) as number
        this.warranties_count = Model.toNumber(data.warranties_count, 0) as number
        this.company_id = data.company_id
        this.user = data.user
        this.secret = data.secret
        this.contact_name = data.contact_name
        this.contact_email = data.contact_email
        this.api_key = data.api_key
        this.account_id = data.account_id
        this.status_change_detected_at = Model.toDate(data.status_change_detected_at)
    }

    get isComplianceVerified() {
        if (this.manufacturer.isGenerac) {
            return this.matched_systems_count > 0 && !this.status.isInvalidOrMissing
        }
        return this.status.isUsesMaintainer && this.matched_systems_count > 0
    }

    get isComplianceNotVerified() {
        return this.status.isUsesMaintainer && this.matched_systems_count === 0 && this.warranties_count > 0
    }

    showCredentials() {
        return this.status.isUsesMaintainer
            ? this.manufacturer.maintainerId
            : api.integrationCredentials.showCredentials(this.id)
    }

    update = (payload: Payload, params?: Params, options?: Options) =>
        api.http.put(Integration.endpoint, { id: this.id, ...payload }, params, options)

    destroy = (params?: Params, options?: Options) => api.http.delete(Integration.endpoint, {
        company_id: this.company_id,
        provider: this.manufacturer.key,
        ...params
    }, options)
}
